import { createAsyncThunk } from "@reduxjs/toolkit";
import ObservationsAPI, { 
    GenerateObservationsRequest,
    CaseObservations,
    GetObservationsParams,
    UpdateObservationsRequest
} from '../../../api/Observations'
import { MessageResponse } from "../../../api/common"


export const createObservationsThunk = createAsyncThunk<
    CaseObservations,
    GenerateObservationsRequest,
    {rejectValue: void}
>(
    'observations/generate',
    async (request: GenerateObservationsRequest, {rejectWithValue}) => {
        try {
            return await ObservationsAPI.create(request);
        } catch(error: any) {
            console.error(error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)


export const getObservationsThunk = createAsyncThunk<
    CaseObservations,
    GetObservationsParams,
    { rejectValue: void }
>(
    'observations/get',
    async (params: GetObservationsParams, { rejectWithValue }) => {
        try {
            // Call the get method from your API
            return await ObservationsAPI.get(params);
        } catch (error: any) {
            console.error(error);
            return rejectWithValue();
        }
    }
);


export const updateObservationsThunk = createAsyncThunk<
    MessageResponse,
    { caseId: string; request: UpdateObservationsRequest },
    { rejectValue: void }
>(
    'observations/update',
    async ({ caseId, request }, { rejectWithValue }) => {
        try {
            return await ObservationsAPI.update(caseId, request);
        } catch(error: any) {
            console.error(error);
            return rejectWithValue(
                error.response?.data?.message || 
                'Failed to update observations'
            );
        }
    }
)